import { CoupomRest } from "@/services/rest/Coupom.rest";
import { CoupomInterface, CoupomLotInterface } from "@/interfaces/Coupom.interface";

export class CoupomService{
    constructor(private _coupons = new CoupomRest()){}

    getCoupons(params: any){
        return this._coupons.getCoupons(params).then((response) =>{
            return response
        })
    }

    getCouponById(id: any){
        return this._coupons.getCouponById(id).then((response) =>{
            return response
        })
    }

    getCheckCoupon(code: any){
        return this._coupons.getCheckCoupon(code).then((response) =>{
            return response
        })
    }

    deleteCoupon(id: any){
        return this._coupons.deleteCoupon(id).catch((error) =>{
            return error.response.data
        })
    }

    createCoupon(data: CoupomInterface){
        return this._coupons.createCoupon(data).then((response) =>{
            return response
        })
    }

    getCoupomLot(params: any){
        return this._coupons.getCouponLots(params).then((response) =>{
            return response
        })
    }

    getCoupomLotById(id: any){
        return this._coupons.getCouponLotById(id).then((response) =>{
            return response
        })
    }

    deleteCoupomLot(id: any){
        return this._coupons.deleteCouponLot(id).catch((error) =>{
            return error.response.data
        })
    }

    createCoupomLot(data: CoupomLotInterface){
        return this._coupons.createCouponLot(data).then((response) =>{
            return response
        })
    }

    downloadCsvLot(id: any){
        return this._coupons.downloadCsvLot(id).then((response) =>{
            return response
        })
    }

}